module.exports = __webpack_public_path__ + "static/media/3.3a7ad897.jpg";